<template>
    <section class="task__sectiontop ralt pt-120 pb-120">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xxl-6 col-xl-8 col-lg-8">
                    <div class="section__title text-center ralt mb-60">
                        <form action="#"
                            class="search__component mb-24 d-flex align-items-center justify-content-between wow fadeInUp">
                            <input v-model="trackingNumber" id="trackingNumberInput" placeholder="CC123456789UZ"
                                class="faded-placeholder" @keyup.enter="fetchTrackingData">
                            <button type="button" class="cmn--btn d-flex align-items-center" @click="fetchTrackingData">
                                <span>Kuzatish</span>
                                <span><i class="bi bi-search fz-12"></i></span>
                            </button>
                        </form>
                        <div v-if="loading" class="loader truckWrapper" id="loader">
                            <img src="https://new.pochta.uz/media/animatsion.gif" alt="Yuklanmoqda..."
                                class="loaderImage">
                        </div>
                        <div v-else>
                            <!-- Header End -->
                            <!-- Include your popup section here -->
                        </div>

                        <!-- Error message if no data is found -->
                        <div v-if="errorMessage" class="error-text">
                            <span>{{ errorMessage }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row ralt g-4" v-if="trackingData">
                <h2 class="title wow fadeInUp mb-24 center" id="trackingNumberDisplay">{{ trackingData.number }}</h2>
                <div v-if="trackingData.senderCountry" class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 wow fadeInDown">
                    <div class="task__item round16 bgwhite d-flex align-items-center">
                        <div class="thumb">
                            <img src="assets/img/bn/profile.png" alt="img">
                        </div>
                        <div class="content">
                            <h3 class="inter title2 mb-24">Yuboruvchi</h3>
                            <p v-if="trackingData.senderCountry" class="fz-16 fw-400 inter pra mb-40">
                                <strong>Mamlakat: </strong> <br>
                                <span id="senderCountry" class="textrang">{{ trackingData.senderCountry }}</span>
                            </p>
                            <p v-if="trackingData.senderAddress" class="fz-16 fw-400 inter pra mb-40">
                                <strong>Manzil:</strong> <br>
                                <span id="senderAddress" class="textrang">{{ trackingData.senderAddress }}</span>
                            </p>

                            <p v-if="trackingData.senderPostcode" class="fz-16 fw-400 inter pra mb-40">
                                <strong>Pochta indeksi:</strong> <br>
                                <span id="senderPostcode" class="textrang">{{ trackingData.senderPostcode }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="trackingData.recipientCountry" class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 wow fadeInUp">
                    <div class="task__item round16 bgwhite d-flex align-items-center">
                        <div class="thumb">
                            <img src="assets/img/bn/profile.png" alt="img">
                        </div>
                        <div class="content">
                            <h3 class="inter title2 mb-24">Qabul qiluvchi</h3>
                            <p v-if="trackingData.recipientCountry" class="fz-16 fw-400 inter pra mb-40">
                                <strong>Mamlakat:</strong> <br>
                                <span id="recipientCountry" class="textrang">{{ trackingData.recipientCountry }}</span>
                            </p>
                            <p v-if="trackingData.recipientAddress" class="fz-16 fw-400 inter pra mb-40">
                                <strong>Manzil:</strong> <br>
                                <span id="recipientAddress" class="textrang">{{ trackingData.recipientAddress }}</span>
                            </p>
                            <p v-if="trackingData.recipientPostcode" class="fz-16 fw-400 inter pra mb-40">
                                <strong>Pochta indeksi:</strong> <br>
                                <span id="recipientPostcode" class="textrang">{{ trackingData.recipientPostcode
                                    }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-8 col-lg-8">
                    <div class="service__detailswrapper">
                        <div class="trending__based mb-40 bgwhite round16 shadow1">
                            <div class="based__content border round16 bgwhite">
                                <div class="freelancer__education bborderdash pb-30 mb-30">
                                    <h3 class="title2">Kuzatuv</h3>
                                    <ul class="blog__categories" id="combinedTracking">
                                        <li v-for="(event, index) in combinedTracking" :key="index">
                                            <a href="#0" class="d-flex align-items-center">
                                                <span class="fz-12 fw-500 title inter">{{ event.date.toLocaleString()
                                                    }}</span>
                                                <span class="cateicon">
                                                    <img :src="`assets/img/flags/${event.country_code.toLowerCase()}.svg`"
                                                        alt="flag" class="flag-icon">
                                                </span>
                                                <span class="fz-12 d-block fw-500 inter success2 region-info">{{
                                                    event.region }}</span>
                                                <span class="fz-12 d-block fw-500 inter success2 region-info">{{
                                                    event.data }}</span>
                                                <span class="fz-12 fw-500 inter title d-block">{{ event.location
                                                    }}</span>
                                                <span>
                                                    <span class="fz-12 fw-500 inter success2 d-block">{{ event.status
                                                        }}</span>
                                                    <span v-if="event.malumot" class="fz-12 fw-500 inter success2"
                                                        style="color: brown; display: block; font-size: 10px; opacity: 0.6;">
                                                        {{ event.malumot }}
                                                    </span>
                                                    <span v-if="event.malumot2" class="fz-12 fw-500 inter success2"
                                                        style="color: brown; display: block; font-size: 10px; opacity: 0.6;">
                                                        {{ event.malumot2 }}
                                                    </span>
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4">
                    <div class="basic__skilled__wrapper">
                        <div class="darrell__profile round16 bgwhite">
                            <div id="adCarousel" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <a href="https://uz.post" target="_blank">
                                            <img src="assets/img/reklama/11.png" class="d-block w-100" alt="ad1">
                                        </a>
                                    </div>
                                    <div class="carousel-item">
                                        <a href="https://uz.post" target="_blank">
                                            <img src="assets/img/reklama/12.png" class="d-block w-100" alt="ad2">
                                        </a>
                                    </div>
                                    <div class="carousel-item">
                                        <a href="https://uz.post" target="_blank">
                                            <img src="assets/img/reklama/13.png" class="d-block w-100" alt="ad3">
                                        </a>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#adCarousel"
                                    data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#adCarousel"
                                    data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            trackingNumber: '',
            loading: false,
            trackingData: null,
            combinedTracking: [],
            errorMessage: null,
        };
    },
    methods: {
        fetchTrackingData() {
            this.loading = true;
            this.trackingData = null;
            this.combinedTracking = [];
            this.errorMessage = null;

            const xhr = new XMLHttpRequest();
            xhr.open('GET', `https://tracking.pochta.uz/api/v1/public/test/${this.trackingNumber}/`, true);
            xhr.onload = () => {
                this.loading = false;
                if (xhr.status >= 200 && xhr.status < 300) {
                    const data = JSON.parse(xhr.responseText);
                    console.log(data)
                    if (Array.isArray(data) && data.length > 0 && data[0].OperationalMailitems) {
                        const mailItem = data[0].OperationalMailitems.TMailitemInfoFromScanning[0];
                        this.trackingData = this.extractTrackingData(mailItem);
                        this.processEvents(mailItem.Events.TMailitemEventScanning, mailItem.DestCountry.Code);
                    } else {
                        this.processAlternativeData(data);
                    }
                } else {
                    this.errorMessage = 'Malumot topilmadi';
                }
            };
            xhr.onerror = () => {
                this.loading = false;
                this.errorMessage = 'Sorovni yuborishda xatolik yuz berdi';
            };
            xhr.send();
        },
        extractTrackingData(mailItem) {
            return {
                number: mailItem.InternationalId,
                senderCountry: mailItem.OrigCountry.Name || '',
                senderAddress: mailItem.OrigAddress || '',
                senderPostcode: mailItem.OrigPostcode || '',
                recipientCountry: mailItem.DestCountry.Name || '',
                recipientAddress: mailItem.DestAddress || '',
                recipientPostcode: mailItem.DestPostcode || ''
            };
        },
        processEvents(events, countryCode) {
            const lang = this.$i18n?.locale || 'uz';
            this.combinedTracking = events.map(event => ({
                date: new Date(event.LocalDateTime),
                date1: new Date(event.GmtDateTime),
                location: event.EventOffice?.Name || 'Manzil yoq',
                status: this.getLocalizedStatus(event.IPSEventType, lang),
                malumot: event.RetentionReason?.Name || '',
                malumot2: event.NonDeliveryReason?.Name || '',
                country_code: countryCode
            })).sort((a, b) => b.date - a.date);
        },
        processAlternativeData(data) {
            this.trackingData = {
                number: data.header?.data?.order_number || data.gdeposilka?.data?.tracking_number || 'Malumot yoq',
                senderCountry: data.header?.data?.locations?.[0]?.address_city || '',
                senderAddress: data.header?.data?.locations?.[0]?.address || '',
                senderPostcode: data.header?.data?.locations?.[0]?.postcode || '',
                recipientCountry: data.header?.data?.locations?.[1]?.address_city || '',
                recipientAddress: data.header?.data?.locations?.[1]?.address || '',
                recipientPostcode: data.header?.data?.locations?.[1]?.postcode || ''
            };
            this.mergeAlternativeTrackingData(data);
        },
        mergeAlternativeTrackingData(data) {
            let shipoxList = this.mapShipoxData(data.shipox);
            let gdeposilkaList = this.mapGdeposilkaData(data.gdeposilka);
            this.combinedTracking = [...shipoxList, ...gdeposilkaList].sort((a, b) => b.date - a.date);
        },
        mapShipoxData(shipox) {
            return shipox?.data?.list?.map(item => ({
                date: new Date(item.date),
                data: item.data || 'UzPost',
                location: item.warehouse?.name || '',
                status: this.getStatusText(item.status_desc),
                country_code: 'UZ'
            })) || [];
        },
        mapGdeposilkaData(gdeposilka) {
            return gdeposilka?.data?.checkpoints?.map(item => ({
                date: new Date(item.time),
                location: item.location_translated || '',
                region: item.courier?.name || '',
                status: this.getStatusText(item.status_name),
                country_code: item.courier?.country_code || ''
            })) || [];
        },
        getLocalizedStatus(eventType, lang) {
            if (!eventType) return 'Status noaniq';
            return lang === 'ru' ? eventType.LocalName_ru || eventType.Name : eventType.LocalName_uz || eventType.Name;
        },
        getStatusText(statusDesc) {
            return statusDesc || 'Status noaniq';
        }
    }
};
</script>

<!-- End -->










<style scoped>
#adCarousel .carousel-control-prev,
#adCarousel .carousel-control-next {
    display: none;
    /* Tugmalarni yashirin holatga keltiramiz */
}

#adCarousel:hover .carousel-control-prev,
#adCarousel:hover .carousel-control-next {
    display: block;
    /* Hover holatida tugmalarni ko'rsatamiz */
}

.hidden {
    display: none;
}

.loading-text {
    font-size: 40px;
    color: #f39c12;
    margin-top: 10px;
}

.error-text {
    font-size: 40px;
    color: red;
    margin-top: 10px;
}

.carousel-item img {
    width: 100%;
    height: auto;
    object-fit: cover;
    /* Rasmni containerga moslashtirish, ya'ni o'zgarmas holda to'liq qamrab olish */
}

.footer__section {
    position: relative;
    margin-top: 20px;
    /* Footerning yuqori qismidan bo'shliq */
    background-color: #333;
    /* Agar kerak bo'lsa, fon rangini o'zgartiring */
    padding: 20px 0;
    /* Footer uchun ichki bo'shliq */
}

.region-info {
    font-size: 10px;
    color: #888;
    display: block;
    /* Yangi qatorga chiqishini ta'minlash */
}

.loaderImage {
    width: 600px;
    /* Rasm kengligi */
    height: auto;
    /* Asl nisbatni saqlash */
}

/* 750px dan kichik ekranlar uchun qo'llanadigan uslublar */
@media (max-width: 750px) {

/* Popupni markazga joylashtirish */
/* Popupning umumiy uslubi (750px dan katta ekranlar uchun eski ko'rinish) */
.popup {
   position: fixed;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   width: 400px;
   background-color: white;
   /* border-radius: 8px; */
   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
   overflow: hidden;
   z-index: 1000;
}

.popup-content {
   padding: 20px;
}

.close-btn {
   position: absolute;
   top: 10px;
   right: 10px;
   font-size: 20px;
   color: #333;
   cursor: pointer;
}

/* Matnlarni markazlash va joylashtirish */
.popup h2 {
   text-align: center;
   font-size: 18px;
   margin-bottom: 15px;
   font-weight: bold;
   color: #183e98;
}

ul.blog__categories {
   list-style: none;
   padding: 0;
   margin: 0;
}

ul.blog__categories li {
   /* display: flex; */
   flex-direction: column;
   padding: 10px;
   border-bottom: 1px solid #f0f0f0;
}

ul.blog__categories li a {
   display: flex;
   flex-wrap: wrap;
   justify-content: space-between;
   align-items: center;
   text-decoration: none;
   color: #333;
}

ul.blog__categories li span {
   font-size: 14px;
   /* color: #555; */
}

/* Flag uchun rasmni moslashtirish */
.flag-icon {
   width: 20px;
   height: auto;
   margin-right: 8px;
}

/* Mobil qurilmalarga moslashtirish faqat ekran kengligi 750px dan kichik bo'lsa */
@media (max-width: 750px) {
   .popup {
      width: 90%;
      max-width: none;
   }

   ul.blog__categories li {
      flex-direction: column;
      align-items: flex-start;
   }

   ul.blog__categories li a {
      flex-direction: column;
      align-items: flex-start;
   }

   ul.blog__categories li span {
      font-size: 12px;
   }

   .popup {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 400px;
      background-color: white;
      z-index: 1100;
      /* Yuqori qiymat beriladi */
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      overflow: hidden;
   }

   .header-section {
      position: relative;
      z-index: 100;
      /* Pastroq qiymat qo'yiladi */
   }

   .sub-menu {
      z-index: 100;
      /* Menyular pastroq bo'lishi uchun */
   }

}
}


.search__component input {
    width: 100%;
    text-align: left;
    padding-left: 10px; /* Matnni chap tomonga yaqinlashtirish uchun */
}
</style>